// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c8adea7b","239":"cc057bef","453":"b9afefc6","732":"9cdc9e90"}[chunkId] + ".chunk.js";
};